import { Component, OnInit, ViewChild } from '@angular/core';

import { GlobalService } from '../../../../services/global.service';
import { ChatService } from '../../services/chat.service';

import { Ng2ImgToolsService } from 'ng2-img-tools';

import { Observable } from 'rxjs/Observable';
import { finalize, catchError } from 'rxjs/operators';
import { error } from '@firebase/database/dist/src/core/util/util';

@Component({
  selector: 'app-add-files',
  templateUrl: './add-files.component.html',
  styleUrls: ['./add-files.component.css']
})
export class AddFilesComponent implements OnInit {

  @ViewChild('fileUploader') fileUploader: any;
  fileCount = 0;

  resized_image_file: any;

  constructor(
    public _globalService: GlobalService,
    public _chatService: ChatService,
    private _ng2ImgToolsService: Ng2ImgToolsService
  ) { }

  ngOnInit() {
  }

  sendFiles() {
    // console.log(this.fileUploader.files);

    if (this.fileUploader.files.length) {
      const files = this.fileUploader.files;
      let fileType: number;
      this.fileCount = 0;
      let total_fileSize: any = 0;

      this.fileCount = files.length;

      files.forEach(e => {
        total_fileSize = total_fileSize + e.size;
      });

      total_fileSize = total_fileSize / (1024 * 1024);
      // console.log('total_fileSize ', total_fileSize);

      if (files.length > 5) {
        this._globalService.openSnackBar('you can send upto 5 files only', 'Dismiss');
      } else if (total_fileSize > 25) {
        this._globalService.openSnackBar('you can not send more than 25 MB', 'Dismiss');
      } else {
        this._globalService.global_loader = true;
        files.forEach(e => {
          if (e.type.toString().includes('image')) {
            fileType = 2;
          } else if (e.type.toString().includes('video')) {
            fileType = 3;
          } else if (e.type.toString().includes('audio')) {
            fileType = 4;
          } else {
            fileType = 6;
          }
          this.uploadFile2(e, fileType);
        });

      }
    }

  }



  // put method to upload
  uploadFile2(file, fileType) {

    let location: any = 'others';
    if (fileType === 2) {
      location = 'images';
    } else if (fileType === 3) {
      location = 'videos';
    } else if (fileType === 4) {
      location = 'audios';
    }

    const file_path = this._globalService.root_path + '/' + this._globalService.domain +
      '/chat' + '/' + location + '/' + (new Date().getTime() + Math.random()) + '_' + file.name;

    const fileRef = this._globalService._fireStorage.ref(file_path);

    const uploadTask: any = this._globalService._fireStorage.ref(file_path).put(file);

    uploadTask.snapshotChanges().pipe(
      catchError(error => {
        // console.log('catchError', error);
        this._globalService.global_loader = false;
        this._globalService.openSnackBar('error occured', 'Dismiss');
        return error;
      }),
      finalize(() => {
        // console.log('down url', fileRef.getDownloadURL());
        fileRef.getDownloadURL()
          .first()
          .subscribe(
          downloaded_url => {
            // console.log('uploaded data ');
            // console.log('upload data ', downloaded_url);

            if (fileType === 2) {
              this.compressImage(file, downloaded_url);
            } else {

              this._chatService.sendMessage(downloaded_url, fileType)
                .then((resp) => {
                  // console.log('fileCount', this.fileCount, fileType, downloaded_url);
                  if (this.fileCount === 1) {
                    this._globalService.global_loader = false;
                    this.fileUploader.clear();
                    this._chatService.display_add_files = false;
                  }
                  this.fileCount -= 1;

                  this._chatService.onUnseenCount();
                  this._chatService.onLastMessageAdded();
                });

            }


          },
          err => {
            this._globalService.global_loader = false;
            this._globalService.openSnackBar('error occured', 'Dismiss');
            // console.log('path sub errrorrrr');
          });
      })
    ).subscribe(
      snapshot => {
        // console.log('snapshot', snapshot);
      },
      err => {
        // console.log('errorrr', err);
      },
      () => {
        // console.log('complete')
        // console.log('complete ',  uploadTask.snapshot.downloadURL);
      });

  }

  compressImage(image, downloaded_url) {
    this._ng2ImgToolsService.compress([image], 0.3).subscribe(result => {
      // console.log('compress image', result);
      this.resizeImage(result, downloaded_url);
    }, err => {
      this.resizeImage(image, downloaded_url);
    });
  }

  resizeImage(image, downloaded_url) {
    this._ng2ImgToolsService.resize([image], 400, 400).subscribe(result => {
      // console.log('resize image', result);
      this.uploadThumbnailImage(result, downloaded_url);
    }, err => {
      this.uploadThumbnailImage(image, downloaded_url);
    });
  }


  // put method to upload
  uploadThumbnailImage(file, downloaded_url) {

    const file_path = this._globalService.root_path + '/' + this._globalService.domain +
      '/chat' + '/' + 'images' + '/' + (new Date().getTime() + Math.random()) + '_' + 'Thumbnail' + file.name;

    const fileRef = this._globalService._fireStorage.ref(file_path);

    const uploadTask: any = this._globalService._fireStorage.ref(file_path).put(file);

    uploadTask.snapshotChanges().pipe(
      catchError(error => {
        // console.log('catchError', error);
        this._globalService.global_loader = false;
        this._globalService.openSnackBar('error occured', 'Dismiss');
        return error;
      }),
      finalize(() => {
        fileRef.getDownloadURL()
          .first()
          .subscribe(
          thumbnail_url => {
            // console.log('thumbnail data ', thumbnail_url);

            this._chatService.sendMessage(downloaded_url, 2, thumbnail_url)
              .then((resp) => {
                if (this.fileCount === 1) {
                  this._globalService.global_loader = false;
                  this.fileUploader.clear();
                  this._chatService.display_add_files = false;
                }
                this.fileCount -= 1;

                this._chatService.onUnseenCount();
                this._chatService.onLastMessageAdded();
              });


          },
          err => {
            this._globalService.global_loader = false;
            this._globalService.openSnackBar('error occured', 'Dismiss');
            // console.log('path sub errrorrrr');
          });
      })
    ).subscribe(
      snapshot => {
        // console.log('snapshot', snapshot);
      },
      err => {
        // console.log('errorrr', err);
      },
      () => {
        // console.log('complete')
        // console.log('complete ',  uploadTask.snapshot.downloadURL);
      });

  }







}



// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/add-files/add-files.component.ts